// Third Party
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

// Types
import ComparisonItem from '@/types/comparison-item';
import Comparison from '@/types/comparison';
import Nullable from '@/types/nullable';
import User from '@/types/user';

// Components
import EditBenchmarkHolding from '@/views/components/edit-benchmark/EditBenchmarkHolding';

// Utils
import { PERMISSIONS, userHasPermissionEnabled } from '@/utils/permissions';
import Icon from '@/views/components/common/Icon';
import { formatMessage } from '@/utils/i18n';

type BenchmarkCollapsibleProps = {
  comparison: Comparison;
  item: ComparisonItem;
  user?: Nullable<User>;
};

const BenchmarkCollapsible = ({ item, user, comparison }: BenchmarkCollapsibleProps) => {
  const showCurrencies = !!user && !!comparison.showBaseCurrencies && userHasPermissionEnabled(user, PERMISSIONS.CURRENCY_CONVERSIONS);

  return (
    <details className="benchmark-disclosure">
      <summary className="benchmark-summary">
        <span className="body-md-semi-responsive">{formatMessage('Comparison.HistoricalScenarios.Benchmarks', { count: item.holdings.length })}</span>
        <Icon type="ds-chevron-right" size={24} className="benchmark-summary-icon" />
      </summary>
      <div className="comparison-benchmark">
        <PerfectScrollbar className="benchmark-holdings-container">
          {item.holdings.map(holding => (
            <EditBenchmarkHolding
              readOnly
              holdingCount={item.holdings.length}
              key={holding.id}
              holding={holding}
              showCurrencies={showCurrencies}
              disabled
              showDelete={false}
            />
          ))}
        </PerfectScrollbar>
      </div>
    </details>
  );
};

export default BenchmarkCollapsible;
